export interface QuestionnaireDisplayRange {
  min: number;
  max: number;
  step: number;
}

const DEFAULT_QUESTIONNAIRE_DISPLAY_RANGE = {
  min: 1,
  max: 10,
  step: 1,
};

export function getQuestionnaireDisplayRange(
  config: unknown,
): QuestionnaireDisplayRange {
  if (!config || typeof config !== "object" || !("range" in config)) {
    return DEFAULT_QUESTIONNAIRE_DISPLAY_RANGE;
  }

  const range = config.range;

  if (!range || typeof range !== "object") {
    return DEFAULT_QUESTIONNAIRE_DISPLAY_RANGE;
  }

  if (!("min" in range) || !("max" in range)) {
    return DEFAULT_QUESTIONNAIRE_DISPLAY_RANGE;
  }

  const step = "step" in range ? range.step : 1;

  if (
    typeof range.min !== "number" ||
    typeof range.max !== "number" ||
    typeof step !== "number" ||
    step <= 0
  ) {
    return DEFAULT_QUESTIONNAIRE_DISPLAY_RANGE;
  }

  return {
    min: range.min,
    max: range.max,
    step: step,
  };
}
